import React, { useState } from 'react';
import { MessageCircle, ArrowLeft, ArrowRight, Camera, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AdditionalDetailsScreen = () => {
  const [details, setDetails] = useState('');
  const [images, setImages] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setShowConfirmDialog(true);
  };

  const handleConfirmClose = () => {
    navigate('/');
  };

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const newImages = files.map(file => ({
      id: Date.now(),
      url: URL.createObjectURL(file),
      file: file
    }));
    setImages(prev => [...prev, ...newImages]);
  };

  const removeImage = (imageId) => {
    setImages(prev => prev.filter(img => img.id !== imageId));
  };

  const handleNext = () => {
    navigate('/search');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Progress Bar */}
      <div className="h-1 bg-blue-600 w-full" />

      {/* Header with Back and Close buttons */}
      <div className="p-4 flex justify-between items-center">
        <button onClick={() => navigate(-1)} className="p-2">
          <ArrowLeft className="w-6 h-6 text-gray-600" />
        </button>
        <button onClick={handleClose} className="p-2">
          <X className="w-6 h-6 text-gray-600" />
        </button>
      </div>

      {/* Content */}
      <div className="px-4 pb-24">
        <div className="max-w-md mx-auto">
          {/* Icon and Title */}
          <div className="mb-8">
            <MessageCircle className="w-16 h-16 text-blue-600 mb-4" />
            <h1 className="text-2xl font-bold text-gray-800">
              Mai multe detalii
            </h1>
            <p className="text-gray-600 mt-2">
              Adaugă orice informații care ne-ar putea ajuta să înțelegem mai bine situația
            </p>
          </div>

          {/* Text Area for Details */}
          <div className="space-y-6">
            <div>
              <textarea
                className="w-full p-4 bg-gray-50 rounded-xl h-32 resize-none"
                placeholder="Descrie detalii adiționale despre problema ta..."
                value={details}
                onChange={(e) => setDetails(e.target.value)}
              />
            </div>

            {/* Image Upload Section */}
            <div>
              <p className="text-gray-700 text-lg mb-2">Poze adiționale (opțional)</p>
              <div className="grid grid-cols-3 gap-2 mb-4">
                {images.map((img) => (
                  <div key={img.id} className="relative">
                    <img
                      src={img.url}
                      alt="Upload preview"
                      className="w-full h-24 object-cover rounded-lg"
                    />
                    <button
                      onClick={() => removeImage(img.id)}
                      className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                    >
                      ×
                    </button>
                  </div>
                ))}
                {images.length < 3 && (
                  <label className="w-full h-24 bg-gray-50 rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-100">
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleImageUpload}
                    />
                    <Camera className="w-6 h-6 text-gray-400" />
                  </label>
                )}
              </div>
              <p className="text-sm text-gray-500">
                Poți adăuga până la 3 poze
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Continue Button - Fixed at bottom */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t">
        <div className="max-w-md mx-auto">
          <button
            onClick={handleNext}
            className="w-full bg-blue-600 text-white p-4 rounded-xl font-medium hover:bg-blue-700 flex items-center justify-center"
          >
            Caută vulcanizare
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Ești sigur că vrei să renunți?
            </h3>
            <p className="text-gray-600 mb-6">
              Dacă închizi acum, vei pierde toate informațiile introduse.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => setShowConfirmDialog(false)}
                className="flex-1 py-3 px-4 rounded-xl bg-gray-100 text-gray-700 font-medium"
              >
                Nu, rămân
              </button>
              <button
                onClick={handleConfirmClose}
                className="flex-1 py-3 px-4 rounded-xl bg-red-600 text-white font-medium"
              >
                Da, renunț
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdditionalDetailsScreen;